module.exports = __webpack_public_path__ + "static/media/intro-mobile.17f0dadc.png";